import { createContext, Dispatch, ReactNode, SetStateAction, useContext, useMemo, useState } from 'react';

import { Course } from '../../db/courses/types';

interface CourseContextType {
  course: Course | null;
  setCourse: Dispatch<SetStateAction<Course | null>>;
}

const CourseContext = createContext<CourseContextType | undefined>(undefined);

export function useCourseContext() {
  const context = useContext(CourseContext);
  if (!context) {
    throw new Error('Using useCourseContext outside CourseContextProvider is not allowed.');
  }
  return context;
}

function useCourseContextProviderVM() {
  const [course, setCourse] = useState<Course | null>(null);

  return useMemo(
    () => ({
      course,
      setCourse,
    }),
    [course]
  );
}

export interface CourseContextProviderProps {
  children: ReactNode;
}

export function CourseContextProvider({ children }: CourseContextProviderProps) {
  const providerValue = useCourseContextProviderVM();
  return <CourseContext.Provider value={providerValue}>{children}</CourseContext.Provider>;
}
